import React, { useEffect, useState } from "react";
import api from "../../services/api";

function PendingVerificationScreen({ user, onLogout }) {
  const [status, setStatus] = useState("ONBOARDING_SUBMITTED");
  const [checklist, setChecklist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastChecked, setLastChecked] = useState(new Date());
  const [submittedAt, setSubmittedAt] = useState(null);

  const fetchStatus = async () => {
    try {
      const data = await api.getOnboardingStatus();
      const nextStatus = data?.status || "ONBOARDING_SUBMITTED";
      setStatus(nextStatus);
      setChecklist(Array.isArray(data?.checklist) ? data.checklist : []);
      setSubmittedAt(data?.onboarding?.submitted_at || null);
      setLastChecked(new Date());
      if (nextStatus === "TEMP" || nextStatus === "VERIFIED" || nextStatus === "ACTIVE") {
        window.location.reload();
      }
    } catch (err) {
      console.warn("Status fetch failed:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
    const timer = setInterval(fetchStatus, 30000);
    return () => clearInterval(timer);
  }, []);

  const handleLogout = () => {
    api.clearToken();
    if (onLogout) onLogout();
    window.location.href = "/login";
  };

  const done = checklist.filter((c) => c.done).length;
  const total = checklist.length || 3;
  const progress = checklist.length ? Math.round((done / total) * 100) : 33;

  const rows = [
    { label: "Onboarding form submitted", state: "done" },
    { label: "Document verification", state: progress >= 66 ? "done" : "progress" },
    { label: "HR review & approval", state: progress >= 100 ? "done" : "pending" },
  ];

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#dfe5f2",
          fontFamily: "'DM Sans',sans-serif",
        }}
      >
        <div
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 14,
            padding: "20px 24px",
            fontSize: 14,
          }}
        >
          Loading verification status...
        </div>
      </div>
    );
  }

  if (status === "REJECTED") {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#dfe5f2",
          fontFamily: "'DM Sans',sans-serif",
        }}
      >
        <div
          style={{
            width: "min(560px, calc(100% - 24px))",
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 16,
            padding: 22,
          }}
        >
          <div
            style={{
              fontFamily: "'Outfit',sans-serif",
              fontSize: 28,
              fontWeight: 800,
              color: "#991b1b",
              marginBottom: 8,
            }}
          >
            Verification Rejected
          </div>
          <div style={{ fontSize: 14, color: "#64748b", marginBottom: 14 }}>
            Please sign in again and resubmit onboarding details.
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={fetchStatus}
              style={{
                flex: 1,
                height: 40,
                borderRadius: 10,
                border: "1px solid #cbd5e1",
                background: "#fff",
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Refresh
            </button>
            <button
              onClick={handleLogout}
              style={{
                flex: 1,
                height: 40,
                borderRadius: 10,
                border: "none",
                background: "#ef4444",
                color: "#fff",
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#dfe5f2",
        overflowY: "auto",
        fontFamily: "'DM Sans',sans-serif",
      }}
    >
      <header
        style={{
          height: 72,
          background: "#fff",
          borderBottom: "1px solid #dbe3ef",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src="/logo.png" alt="logo" style={{ width: 40, height: 40, borderRadius: 8 }} />
          <div>
            <div
              style={{
                fontFamily: "'Outfit',sans-serif",
                fontSize: 18,
                fontWeight: 800,
                lineHeight: 1.1,
                color: "#0f172a",
              }}
            >
              AMSHRMS
            </div>
            <div style={{ fontSize: 13, color: "#f59e0b", lineHeight: 1.2 }}>Pending Verification</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.1, color: "#0f172a" }}>
              {user?.name || "User"}
            </div>
            <div style={{ fontSize: 12, lineHeight: 1.1, color: "#94a3b8" }}>
              {user?.id || user?.emp_id || user?.empId}
            </div>
          </div>
          <button
            onClick={handleLogout}
            style={{
              height: 40,
              padding: "0 16px",
              borderRadius: 10,
              border: "1px solid #d1d5db",
              background: "#fff",
              color: "#ef4444",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Sign Out
          </button>
        </div>
      </header>

      <main style={{ display: "flex", justifyContent: "center", padding: "24px 12px 18px" }}>
        <div
          style={{
            width: "min(740px, calc(100% - 8px))",
            background: "#fff",
            border: "1px solid #dbe3ef",
            borderRadius: 24,
            padding: "26px 22px 18px",
            boxShadow: "0 12px 26px rgba(15,23,42,0.07)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div
              style={{
                width: 68,
                height: 68,
                borderRadius: "50%",
                background: "#f8f3df",
                display: "grid",
                placeItems: "center",
                fontSize: 28,
              }}
            >
              ...
            </div>
            <div
              style={{
                border: "2px solid #f4ce6e",
                borderRadius: 999,
                color: "#d88a00",
                background: "#fffdf6",
                fontWeight: 700,
                fontSize: 14,
                padding: "7px 14px",
              }}
            >
              In Progress
            </div>
          </div>

          <div style={{ textAlign: "center", marginBottom: 18 }}>
            <div
              style={{
                fontFamily: "'Outfit',sans-serif",
                fontSize: 28,
                fontWeight: 800,
                color: "#0f172a",
                lineHeight: 1.1,
                marginBottom: 6,
              }}
            >
              HR Verification Pending
            </div>
            <div style={{ color: "#546a86", fontSize: 15 }}>Your onboarding is under review by HR team.</div>
          </div>

          <section style={{ background: "#f8fafc", borderRadius: 18, border: "1px solid #d8e0eb", padding: 16, marginBottom: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 18, fontWeight: 800, color: "#0f172a" }}>
                Verification Checklist
              </div>
              <div style={{ background: "#fff", color: "#66788f", fontSize: 14, borderRadius: 999, padding: "5px 11px" }}>
                Est. ~1-2 hours
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {rows.map((row, idx) => (
                <div key={idx} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 14 }}>
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: row.state === "done" ? "#60a5fa" : row.state === "progress" ? "#f59e0b" : "#cbd5e1",
                      color: "#fff",
                      display: "grid",
                      placeItems: "center",
                      fontWeight: 800,
                      fontSize: 13,
                    }}
                  >
                    {row.state === "done" ? "\u2713" : ""}
                  </div>
                  <span style={{ color: row.state === "done" ? "#0f172a" : "#64748b" }}>{row.label}</span>
                </div>
              ))}
            </div>
          </section>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#f1f5f9",
              borderRadius: 12,
              padding: "11px 14px",
              marginBottom: 14,
              fontSize: 14,
            }}
          >
            <span style={{ color: "#55657e" }}>
              Logged in as <strong style={{ color: "#0f172a" }}>{user?.id || user?.emp_id || user?.empId}</strong>
            </span>
            <span style={{ background: "#fff", borderRadius: 999, padding: "4px 10px", color: "#55657e", fontSize: 12 }}>
              Submitted: {submittedAt ? new Date(submittedAt).toLocaleDateString("en-IN") : "Today"}
            </span>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={fetchStatus}
              style={{
                flex: 1,
                height: 44,
                borderRadius: 11,
                border: "none",
                color: "#fff",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
                background: "linear-gradient(135deg,#4f46e5,#6366f1)",
              }}
            >
              Refresh Status
            </button>
            <button
              onClick={handleLogout}
              style={{
                flex: 1,
                height: 44,
                borderRadius: 11,
                border: "1px solid #cbd5e1",
                background: "#fff",
                color: "#374151",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Sign Out
            </button>
          </div>

          <div
            style={{
              marginTop: 12,
              borderTop: "1px solid #e2e8f0",
              paddingTop: 10,
              textAlign: "center",
              color: "#98a7ba",
              fontSize: 12,
            }}
          >
            Auto-refreshes every 30 seconds | Last checked: {lastChecked.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" })}
          </div>
        </div>
      </main>
    </div>
  );
}

export default PendingVerificationScreen;
